import { useEffect } from 'react';
import { X } from 'lucide-react';
import ContactForm from './ContactForm';

interface AddContactPopupProps {
  onClose: () => void;
  onSuccess: () => void;
}

export default function AddContactPopup({ onClose, onSuccess }: AddContactPopupProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-dark-800 rounded-lg max-w-4xl w-full p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Add New Contact</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <ContactForm 
          onSuccess={onSuccess}
          onCancel={onClose}
        />
      </div>
    </div>
  );
}